'use client'

import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'

// Where a promo code arriving via the URL (e.g. a landlord's shared
// `partment.co/stays?promo=CODE` link) is stashed so it survives the walk
// through the funnel (home -> listing -> property -> checkout) and can be
// auto-applied on the checkout page.
export const PROMO_STORAGE_KEY = 'partment_stays_promo'

/**
 * Captures a `?promo=` (or `?coupon=`) query param into localStorage.
 *
 * Mounted app-wide in the root layout so it works regardless of which Stays
 * page the shared link lands on. Renders nothing.
 */
const StaysPromoCapture = () => {
  const searchParams = useSearchParams()

  useEffect(() => {
    const raw = searchParams.get('promo') || searchParams.get('coupon')
    if (!raw) {
      return
    }
    const code = raw.trim().toUpperCase()
    if (!code) {
      return
    }
    try {
      localStorage.setItem(PROMO_STORAGE_KEY, code)
    } catch {
      // localStorage may be unavailable (private mode / SSR) — ignore.
    }
  }, [searchParams])

  return null
}

export default StaysPromoCapture
